import React, { useEffect, useState } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import "../../css/Mirissa.css";

import { storage } from "../../firebase";
import { ref, getDownloadURL } from "firebase/storage";

function Anuradhapura() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [img1, setImg1] = useState("");
  const [img2, setImg2] = useState("");

  const [g3, setG3] = useState("");
  const [g4, setG4] = useState("");
  const [g5, setG5] = useState("");
  const [g6, setG6] = useState("");
  const [g7, setG7] = useState("");

  const [act1, setAct1] = useState("");
  const [act2, setAct2] = useState("");
  const [act3, setAct3] = useState("");
  const [act4, setAct4] = useState("");
  const [act5, setAct5] = useState("");
  const [act6, setAct6] = useState("");
  const [act7, setAct7] = useState("");
  const [act8, setAct8] = useState("");
  const [act9, setAct9] = useState("");

  const [imgHero, setImgHero] = useState("");

  useEffect(() => {
    getDownloadURL(ref(storage, "anuradhapura.jpg")).then(setImg1);
    getDownloadURL(ref(storage, "anuradhapura1.jpg")).then(setImg2);

    getDownloadURL(ref(storage, "anuradhapura2.jpg")).then(setG3);
    getDownloadURL(ref(storage, "anuradhapura3.jpg")).then(setG4);
    getDownloadURL(ref(storage, "anuradhapura4.jpg")).then(setG5);
    getDownloadURL(ref(storage, "anuradhapura5.jpg")).then(setG6);
    getDownloadURL(ref(storage, "anuradhapura6.jpg")).then(setG7);

    // Activity icons
    getDownloadURL(ref(storage, "Sri Maha Bodhi.png")).then(setAct1);
    getDownloadURL(ref(storage, "Ruwanwelisaya.png")).then(setAct2);
    getDownloadURL(ref(storage, "Abhayagiriya.png")).then(setAct3);

    getDownloadURL(ref(storage, "Sandakada Pahana.png")).then(setAct4);
    getDownloadURL(ref(storage, "Mura Gal.png")).then(setAct5);
    getDownloadURL(ref(storage, "Ancient Building Ruins.png")).then(setAct6);

    getDownloadURL(ref(storage, "Buddist Monks.png")).then(setAct7);
    getDownloadURL(ref(storage, "Tanks.png")).then(setAct8);
    getDownloadURL(ref(storage, "Buddist Paintings.png")).then(setAct9);

    getDownloadURL(ref(storage, "anuradhapura-hero.jpg")).then(setImgHero);
  }, []);

  return (
    <div className="destination-container">
      {/* HERO SECTION */}
      <section
        className="mirissa-hero"
        style={{ backgroundImage: `url(${imgHero})` }}
        data-aos="fade-down"
      >
        <div className="overlay">
          <h1>Anuradhapura</h1>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="mirissa-container">
        {/* LEFT CONTENT */}
        <div className="mirissa-left" data-aos="fade-right">

          <h2>Anuradhapura</h2>
          <p>
            Anuradhapura, Sri Lanka's first capital and a UNESCO World Heritage Site, represents a fascinating journey through ancient history,
            Buddhist heritage and remarkable engineering achievements.
          </p>

          <p>
            Ourof Anuradhapura is specially designed to take you through the city and give you an unforgettable experience of its luxurious culture, pilgrimages and people.
            Anuradhapura is one of the largest cities today in terms of size &ancient ruins .You will get a mentor with excellent local knowledge and communication skills.
            Language guides can be provided on special request.
            For those who love culture and history, this is the perfect tour to enlighten their soul.
          </p>

          <div className="mirissa-top-gallery">
            <img src={img1} alt="View" />
            <img src={img2} alt="Beach" />
          </div>

          <p>
            Anuradhapura is one of the seven kingdoms in the history of Sri Lanka. It is the oldest, the largest and the most rich.
            In 377 BCE, it was declared a kingdom, and King Pandukabhaya made it prosperous.
            It is still considered the capital of the Central-North Province.
            This kingdom existed for 12 centuries until it was destroyed in the 10th century AD.
          </p>

          <div className="mirissa-top-gallery">
            <img src={g3} alt="" />
            <img src={g4} alt="" />
            <img src={g5} alt="" />
          </div>

          <p>
            There are eight significant symbols that represent Sri Lanka's connection with Buddhism, all of which are located in Anuradhapura, thus the collection is known as 'Atmasthana', which means 'eight holy places.' Each of them is associated with a unique story or story. Most of them were built by the kings who ruled the Anuradhapura Kingdom.
            You will visit all these places in our tour of the city of Anuradhapura.
          </p>

          <h3>Sri Maha Bodhi</h3>

          <p>
            That was 288 B.C. It is a BOO tree planted in.
            It is considered sacred as it is believed that Buddha attained enlightenment by meditating under this tree.
          </p>

          <h3>Ruanvelisaya</h3>

          <p>
            It is a "stupa" built by King Dutugamunu and is one of the largest stupas completed to date.
          </p>

          <h3>Thuparamaya</h3>

          <p>
            It is the oldest 'dagoba' in Sri Lanka and, probably, the oldest to be found in the world.
          </p>

          <h3>Lovamahapaya</h3>

          <p>
            The significance of this building is that the roof was once covered with bronze tiles.
          </p>

          <h3>Abahayagiri</h3>

          <p>
            It is one of the largest monasteries in Anuradhapura. It was a monastery with 5000 monks.
          </p>

          <h3>Jethawanaramaya</h3>

          <p>
            This holy place is a World Heritage Site when it can accommodate about 3000 monks. It is very similar to Abhyagiri.
          </p>

          <h3>Mirisawatiya</h3>

          <p>
            This stupa was built by King Tutukemun after conquering King Elara.
          </p>

          <h3>Lankaramaya</h3>

          <p>
            Built by King Valakamba during the reign of Anuradhapura, it is one of the eight sacred places in the city.
          </p>

          <p>
            There are many more places to see and enjoy. Join this day trip to see the major players in the history of Sri Lanka.
            Your love for culture will grow after seeing the wealth of the city.
          </p>

          <p>
            Please include Anuradhapura in your itinerary plan will give you unforgettable experience of its luxurious culture, pilgrimage.
          </p>

          {/* ACTIVITIES SECTION */}
          <div className="mirissa-activities" data-aos="fade-up">

            <details className="activity-box" open>
              <summary>• Religious and Pilgrimage Sites</summary>

              <p>
                Anuradhapura houses eight sacred Buddhist sites, including Sri Maha Bodhi, Ruwanwelisaya,
                and Thuparamaya. These spiritual landmarks symbolize Sri Lanka’s deep Buddhist roots and offer profound religious experiences.
                Each site is historically significant, built by ancient kings,
                making the city a key pilgrimage destination for Buddhist devotees and history enthusiasts.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={act1} alt="Sri Maha Bodhi" />
                  <p>Sri Maha Bodhi</p>
                </div>

                <div className="activity-card">
                  <img src={act2} alt="Ruwanwelisaya" />
                  <p>Ruwanwelisaya</p>
                </div>

                <div className="activity-card">
                  <img src={act3} alt="Abhayagiriya" />
                  <p>Abhayagiriya</p>
                </div>
              </div>
            </details>

            <details className="activity-box">
              <summary>• Historical and Archaeological Significance</summary>

              <p>
                Anuradhapura, Sri Lanka's first kingdom, showcases ancient ruins, monasteries, stupas, and engineering marvels.
                These structures reflect the grandeur and innovation of the Anuradhapura Kingdom.
                Visitors can explore 12 centuries of history, from advanced irrigation systems to bronze-tiled buildings,
                making it a treasure trove for historians and archaeology lovers.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={act4} alt="Sandakada Pahana" />
                  <p>Sandakada Pahana</p>
                </div>

                <div className="activity-card">
                  <img src={act5} alt="Mura Gal" />
                  <p>Mura Gala</p>
                </div>

                <div className="activity-card">
                  <img src={act6} alt="Ruins" />
                  <p>Ancient Building Ruins</p>
                </div>
              </div>
            </details>

            <details className="activity-box">
              <summary>• Cultural and Heritage Experience</summary>

              <p>
                Dive into Anuradhapura’s luxurious culture with guided tours led by local experts.
                Experience the traditions, stories, and architecture that defined this ancient kingdom.
                Visitors will gain a profound appreciation for Sri Lanka’s heritage while enjoying the city's vibrant atmosphere,
                making it an unforgettable cultural journey through time.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={act7} alt="Monks" />
                  <p>Buddist Monks</p>
                </div>

                <div className="activity-card">
                  <img src={act8} alt="Tanks" />
                  <p>Tanks</p>
                </div>

                <div className="activity-card">
                  <img src={act9} alt="Paintings" />
                  <p>Buddist Paintings</p>
                </div>
              </div>

            </details>

          </div>

          {/* PARROT ROCK SECTION */}
          <div className="mirissa-parrot-rock" data-aos="fade-up">

            <div className="parrot-gallery">
              <img src={g6} alt="Gallery 1" />
              <img src={g7} alt="Gallery 2" />
            </div>

          </div>

        </div>

        {/* RIGHT INQUIRY FORM */}
        <div className="mirissa-form" data-aos="fade-left">
          <h3>Make an Inquiry</h3>

          <form
            onSubmit={(e) => {
              e.preventDefault();

              const name = e.target.name.value;
              const email = e.target.email.value;
              const country = e.target.country.value;
              const code = e.target.code.value;
              const phone = e.target.phone.value;
              const arrival = e.target.arrival.value;
              const departure = e.target.departure.value;
              const interest = e.target.interest.value;
              const vehicle = e.target.vehicle.value;   // ✅ NEW
              const adults = e.target.adults.value;
              const kids = e.target.kids.value;
              const message = e.target.message.value;

              const fullMessage = `
                📌 NEW TOUR BOOKING

                👤 Name: ${name}
                📧 Email: ${email}
                🌍 Country: ${country}
                📞 Phone: ${code} ${phone}
                📅 Arrival: ${arrival}
                📅 Departure: ${departure}
                🎯 Interest: ${interest}
                � Vehicle Preference: ${vehicle}
                �👨‍👩‍👧 Adults: ${adults}
                🧒 Kids: ${kids}

                💬 Message: ${message} 
              `;

              // ✅ SEND WHATSAPP
              const whatsappNumber = "94773562768"; // your WhatsApp number
              const whatsappURL =
                "https://wa.me/" + whatsappNumber + "?text=" + encodeURIComponent(fullMessage);

              window.open(whatsappURL, "_blank");

              // ✅ SEND EMAIL
              const mailto =
                "mailto:ceylongracetravels@gmail.com" +
                "?subject=" + encodeURIComponent("New Tour Booking") +
                "&body=" + encodeURIComponent(fullMessage);

              window.location.href = mailto;

              alert("✅ Your Booking is Send!");
            }}
          >
            <input name="name" type="text" placeholder="Name *" />
            <input name="email" type="email" placeholder="Email Address *" />

            <select name="country" required>
              <option value="">Choose Your Country *</option>
              <option value="Afghanistan">Afghanistan</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
              <option value="Botswana">Botswana</option>
              <option value="Brazil">Brazil</option>
              <option value="Brunei">Brunei</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cabo Verde">Cabo Verde</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Central African Republic">Central African Republic</option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
              <option value="Congo, Republic of the">Congo, Republic of the</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Côte d’Ivoire">Côte d’Ivoire</option>
              <option value="Croatia">Croatia</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Eswatini">Eswatini</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Greece">Greece</option>
              <option value="Grenada">Grenada</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-Bissau">Guinea-Bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Honduras">Honduras</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran">Iran</option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Korea, North">Korea, North</option>
              <option value="Korea, South">Korea, South</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Laos">Laos</option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon">Lebanon</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libya">Libya</option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia">Micronesia</option>
              <option value="Moldova">Moldova</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montenegro">Montenegro</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar (Burma)">Myanmar (Burma)</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="North Macedonia">North Macedonia</option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Qatar">Qatar</option>
              <option value="Romania">Romania</option>
              <option value="Russia">Russia</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
              <option value="Saint Lucia">Saint Lucia</option>
              <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">Sao Tome and Principe</option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Serbia">Serbia</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra Leone">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Sudan">South Sudan</option>
              <option value="Spain">Spain</option>
              <option value="Sri Lanka">Sri Lanka</option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syria">Syria</option>
              <option value="Taiwan">Taiwan</option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania">Tanzania</option>
              <option value="Thailand">Thailand</option>
              <option value="Timor-Leste">Timor-Leste</option>
              <option value="Togo">Togo</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Vatican City">Vatican City</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Vietnam">Vietnam</option>
              <option value="Yemen">Yemen</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </select>

            <div className="phone-row">
              <input name="code" className="code" type="text" placeholder="Code" />
              <input name="phone" className="phone" type="text" placeholder="Phone Number *" />
            </div>

            <label htmlFor="arrival">Arrival Date</label>
            <input name="arrival" type="date" />

            <label htmlFor="departure">Departure Date</label>
            <input name="departure" type="date" />

            <select name="interest">
              <option value="">Choose Your Interest *</option>
              <option value="Eco">Eco</option>
              <option value="Beach">Beach</option>
              <option value="Cultural">Cultural</option>
              <option value="Adventure">Adventure</option>
              <option value="Wild Life">Wild Life</option>
              <option value="Relax and Wellness">Relax and Wellness</option>
              <option value="Honeymoon">Honeymoon</option>
              <option value="Ramayana Trail">Ramayana Trail</option>
              <option value="All in one Trails">All in one Trails</option>
            </select>

            <select name="vehicle">
              <option value="">Select Vehicle Type *</option>
              <option value="Sedan – Toyota Prius (3 Pax)">Sedan – Toyota Prius (3 Pax)</option>
              <option value="Sedan – Toyota Axio (3 Pax)">Sedan – Toyota Axio (3 Pax)</option>
              <option value="Sedan – Honda Grace (3 Pax)">Sedan – Honda Grace (3 Pax)</option>
              <option value="Mini – Suzuki Wagon R (2 Pax)">Mini – Suzuki Wagon R (2 Pax)</option>
              <option value="Mini – Toyota Aqua (2 Pax)">Mini – Toyota Aqua (2 Pax)</option>
              <option value="Van – Suzuki Every (4 Pax)">Van – Suzuki Every (4 Pax)</option>
              <option value="Van – Mini Van (4 Pax)">Van – Mini Van (4 Pax)</option>
              <option value="Van – Toyota Noha (4 Pax)">Van – Toyota Noha (4 Pax)</option>
              <option value="Bus – Mitsubishi Rosa (12 Pax)">Bus – Mitsubishi Rosa (12 Pax)</option>
              <option value="Bus – King Long (12 Pax)">Bus – King Long (12 Pax)</option>
            </select>

            <input name="adults" type="number" placeholder="Adults *" />
            <input name="kids" type="number" placeholder="Kids" />

            <textarea name="message" placeholder="Enter your message"></textarea>

            <button type="submit">SUBMIT</button>
          </form>

        </div>

      </section>

      {/* CTA Section */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-box">
          <div className="cta-left">
            <img src={require("../../assets/hile.png")} className="cta-icon" alt="icon" />
            <div className="cta-text">
              <h2>Ready To Adventure And Enjoy Natural</h2>
              <p>Reach Pearl Ceylon Tours For A Secure, Luxurious, And Unforgettable Adventure!</p>
            </div>
          </div>

          <img src={require("../../assets/plan.png")} className="cta-plane" alt="plane" />

          <button className="cta-btn">LET’S GET STARTED</button>
        </div>
      </section>
    </div>
  );
}

export default Anuradhapura;
